export default __webpack_public_path__ + "static/media/BrainBreak cards32.2d1f71bd.png";